@if (event().config?.numberOfPlayersToMainDraw; as numberOfPlayersToMainDraw) {
  <div role="alert" class="alert alert-daxa">
    Los {{ numberOfPlayersToMainDraw }} primeros jugadores de cada grupo clasifican a la siguiente fase
  </div>
}

@for (group of groups(); track group; let first = $first) {
  <div class="row" [ngClass]="{'mt-50': !first}">
    <div class="col-12">
      <group-ui
        [group]="group"
        [drawings]="drawings()"
        [games]="games()"
        [groupsRankings]="groupsRankings()"
      ></group-ui>
    </div>
  </div>
}
